import styled, {StyledComponent} from 'styled-components';
import {FONTS, Typography} from '@fupa/fupa-uikit';
import React from 'react';

export const Label: StyledComponent<React.FC<any>, any> = styled(Typography)<{padding?: number}>`
  &&& {
    justify-self: left;
    font-size: ${FONTS['16']};
    align-self: center;
    padding: ${props => (props.padding ? `0 ${props.padding}px` : 'none')};
  }
`;

export const DataEntry = styled.div<{justify?: string}>`
  width: 100%;
  justify-self: center;
  display: flex;
  justify-content: ${props => props.justify ?? 'space-between'};
  align-items: center;
`;

export const Action = styled.div<{justify?: 'start' | 'end'; span?: number}>`
  grid-column: span ${props => props.span ?? 1};
  justify-self: ${props => props.justify ?? 'start'};
  white-space: nowrap;
`;
